<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  {{"DAYS_CHANGE.DAYS" | translate}}
</div>
<div class="btn-group">
  <button mat-button mat-dialog-close (click)="close()">{{"DAYS_CHANGE.NO" | translate}}</button>
  <button mat-button cdkFocusInitial (click)="changeWeek()">{{"DAYS_CHANGE.YES" | translate}}</button>
</div>
